import { useEffect, useMemo } from "react";
import type { Product } from "../types/Product";
import type { Product as TransformedProduct } from "./products";
import { transformRawProducts } from "./products/transformations";
import { useRecentlyViewedStore } from "../store/recentlyViewedStore";

export const useRecentlyViewed = (
  currentProduct: Product | null,
): TransformedProduct[] => {
  const { products, addProduct } = useRecentlyViewedStore();

  useEffect(() => {
    if (currentProduct) addProduct(currentProduct);
  }, [currentProduct?.id]);

  const filtered = currentProduct
    ? products.filter((p) => p.id !== currentProduct.id)
    : products;

  return useMemo(
    () => transformRawProducts(filtered as any[]),
    [filtered],
  );
};
